import React, {useRef, useState} from 'react'
import ReactToPrint from 'react-to-print'
import Button from '@components/Button'
import Modal from '@components/Modal'
import {PREFIX_EXT_TERMS} from '@i18n/helpers/terms/constants'
import {useApolloQuery} from '@packages/apollo-hooks'
import gql from 'graphql-tag'

import {ContentTerms} from './ContentTerms'

export default function ShowTerms(props) {
  const refTermsCompany = useRef()
  const refTermsJusto = useRef()
  const refPrivacyCompany = useRef()
  const refPrivacyJusto = useRef()
  const {openModal, setOpenModal, websiteId, locale = 'es'} = props
  const termType = props.termType && props.termType.replace(PREFIX_EXT_TERMS, '')
  const {website} = useApolloQuery({
    query: gql`
      query getTerms($websiteId: ID, $locale: String) {
        website(websiteId: $websiteId) {
          _id
          name
          terms(locale: $locale)
          logo {
            _id
            url: resizedURL(height: 200)
          }
        }
      }
    `,
    variables: {websiteId, locale}
  })
  const pageStyle = ``
  const termsTexts = {
    company: 'website_termsAndConditions',
    justo: 'termsAndConditions'
  }
  const privacyTexts = {
    company: 'website_privacy',
    justo: 'privacy'
  }

  const {terms} = website
  const filteredTerms = Object.keys(terms).filter(
    term => termType === term.replace(PREFIX_EXT_TERMS, '')
  )

  const isTermsJusto = filteredTerms.includes(termsTexts.justo) ? true : false
  const isTermsCompany = filteredTerms.includes(termsTexts.company) ? true : false
  const isPrivacyJusto = filteredTerms.includes(privacyTexts.justo) ? true : false
  const isPrivacyCompany = filteredTerms.includes(privacyTexts.company) ? true : false
  const [radio, setRadio] = useState('Company')
  const contentToPrint = () => {
    if (isTermsJusto) {
      if (isTermsCompany) {
        return radio === 'Company' ? refTermsCompany.current : refTermsJusto.current
      }
      return refTermsJusto.current
    } else if (isPrivacyCompany) {
      return radio === 'Company' ? refPrivacyCompany.current : refPrivacyJusto.current
    }
    return refPrivacyJusto.current
  }

  const botonModal = (
    <>
      <ReactToPrint
        pageStyle={pageStyle}
        content={() => contentToPrint()}
        trigger={() => <Button>Descargar PDF</Button>}
      />
      <Button
        danger
        onClick={() => {
          setOpenModal(false)
        }}>
        Aceptar y Cerrar
      </Button>
    </>
  )

  const contentForModal = () => {
    let isTermsTitle
    let tabs
    if (isTermsJusto) {
      isTermsTitle = true
      tabs = tabContent(isTermsCompany, true, termsTexts)
    } else if (isPrivacyJusto) {
      isTermsTitle = false
      tabs = tabContent(isPrivacyCompany, false, privacyTexts)
    }
    return (
      <ContentTerms
        contentTabs={{isTermsTitle, numberOfTabs: tabs.length, tabs}}
        setRadio={setRadio}
      />
    )
  }

  const tabContent = (isCompany, isTerms, textForContent) => {
    const urlImageJusto = '/images/favicon/ms-icon-150x150.png'
    const numberOfTabs = 1 + (isCompany ? 1 : 0)
    const tabs = []
    if (numberOfTabs === 2) {
      const referCompany = isTerms ? refTermsCompany : refPrivacyCompany
      tabs.push({
        checked: true,
        name: website.name,
        urlImage: website.logo.url,
        content: contentSection(textForContent.company, referCompany)
      })
    }
    const referJusto = isTerms ? refTermsJusto : refPrivacyJusto
    tabs.push({
      checked: isCompany ? false : true,
      name: 'Justo',
      urlImage: urlImageJusto,
      content: contentSection(textForContent.justo, referJusto)
    })
    return tabs
  }

  const contentSection = (option, ref) => {
    return filteredTerms.map((term, index) => {
      const componenteReturn = <ContentForSection content={terms[term].content} ref={ref} />
      if (term === option) return componenteReturn
    })
  }
  return openModal ? <Modal bottom={[botonModal]}>{contentForModal()}</Modal> : null
}

const ContentForSection = React.forwardRef<HTMLDivElement, {content: string}>((props, ref) => {
  return <div ref={ref} dangerouslySetInnerHTML={{__html: props.content}} />
})

ContentForSection.displayName = 'ContentForSection'
